module.exports = __webpack_public_path__ + "static/media/education2.0cc2fd05.webp";